<div *ngIf="isLoading" [@fadeInEnter]>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div
  *ngIf="!isLoading"
  [ngStyle]="{ width: '760px', maxWidth: '95vw', minHeight: '100vh' }"
  class="u-margin-center u-padding-40-0"
>
  <div class="u-marginBottom-32 u-textAlign-center">
    <app-avatar-tenant
      class="u-display-inlineBlock u-marginBottom-16"
      [item]="tenant"
      [size]="96"
    >
    </app-avatar-tenant>
    <h5 class="u-marginBottom-8">
      <ng-container [ngSwitch]="viewMode">
        <ng-container *ngSwitchCase="viewModes.overview">
          <b i18n="@@userOnboardingViewGoalSetting.overviewTitle"
            >Set your development goals</b
          >
        </ng-container>
        <ng-container *ngSwitchCase="viewModes.setGoals">
          <b i18n="@@userOnboardingViewGoalSetting.setGoalsTitle"
            >Create and customize your goals</b
          >
        </ng-container>
      </ng-container>
    </h5>
    <div
      class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
    >
      <p i18n="@@userOnboardingViewGoalSetting.desciption">
        These goals help us introduce you to people on the platform. We
        recommend starting with up to 3 goals.
      </p>
    </div>
    <app-progress-steps
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="center center"
      class="u-display-block"
      [currentStep]="3"
      [numberOfSteps]="5"
    >
    </app-progress-steps>
  </div>
  <div>
    <ng-container [ngSwitch]="viewMode">
      <div *ngSwitchCase="viewModes.overview" class="u-textAlign-center">
        <div class="u-marginBottom-16">
          <img
            src="//storage.googleapis.com/ttc-static-images/goal-setting/Empy-state.11FF161.png"
            alt=""
            width="250"
            height="250"
          />
        </div>
        <p
          class="text-heading-6 u-marginBottom-16"
          i18n="@@userOnboardingViewGoalSetting.addGoalPrompt"
        >
          Goals help 10KC introduce you to the right people. Write your first
          goal ✨
        </p>
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="u-marginBottom-16"
          (click)="viewMode = viewModes.setGoals"
          i18n="@@userOnboardingViewGoalSetting.addCta"
        >
          Add goal
        </button>
      </div>
      <div *ngSwitchCase="viewModes.setGoals">
        <p
          *ngIf="
            (group?.field_descriptions | appFind: 'name' : 'offerings')
              ?.description as goalsDescription
          "
          class="color-grey-300 u-text-maxWidth u-marginTop-24 u-marginBottom-16 u-whiteSpace-preLine"
        >
          {{
            goalsDescription
              | translationLookup: ['@@groupOfferingsDescription']
          }}
        </p>
        <app-group-account-goals
          [user]="user"
          [group]="group"
          (goalFormsValid)="areGoalFormsValid = $event"
        ></app-group-account-goals>
        <div class="u-textAlign-center u-marginTop-32">
          <button
            i18n="@@global.continue"
            type="button"
            mat-raised-button
            color="primary"
            (click)="navigateToNextView.emit(group)"
            [disabled]="!areGoalFormsValid"
          >
            Continue
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
